import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const DEFAULT_COLOR = '#41505C';

const Search: FC<IconSvgProps> = ({ color, clss }) => {
    // `Icon` passes 'currentColor' when no color is given: keep the historical grey in that case.
    const fill = color && color !== 'currentColor' ? color : DEFAULT_COLOR;
    const styles = {
        svg: {
            verticalAlign: 'middle',
            overflow: 'hidden',
        },
    };

    return (
        <svg style={{ ...styles.svg }} className={clss} width="22" height="22" viewBox="0 0 22 22">
            <path
                d="M7.652.25c4.094 0 7.413 3.47 7.413 7.75 0 1.856-.624 3.56-1.665 4.894l7.813 7.26c.296.275.322.749.06 1.059a.695.695 0 0 1-.93.13l-.084-.068-7.87-7.314a7.192 7.192 0 0 1-4.737 1.789C3.558 15.75.24 12.28.24 8 .24 3.72 3.56.25 7.652.25zm0 1.5C4.35 1.75 1.674 4.548 1.674 8s2.676 6.25 5.978 6.25c3.302 0 5.978-2.798 5.978-6.25s-2.676-6.25-5.978-6.25z"
                fill={fill}
                fillRule="evenodd"
            />
        </svg>
    );
};

export default Search;
